import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import { BackIcon } from '../assets/icons/icons';
import Entries from '../components/Entries/Entries';
import './train-mind.css';

export default function TrainMindEntriesPage() {
  const navigate = useNavigate();

  return (
    <>
      <NavBar />
      <main className="web-view">
        <div className="trainmind-container">
          <div className="trainmind-header">
            <BackIcon className="back-icon" onClick={() => navigate('/train-mind')} />
            <h1>Old Entries</h1>
          </div>
          <div className="trainmind-subnav">
            <button className="subnav-item" onClick={() => navigate('/train-mind')}>Write</button>
            <button className="subnav-item active">Old Entries</button>
          </div>
          <div className="trainmind-content">
            <Entries />
          </div>
        </div>
      </main>
    </>
  );
}
